/* Lavender Farm Simulator — v638 · the Lavender Farm Simulator Discord, from the game and the Grower Community.
   - Game: Leaderboard → My farm shows "Join our Discord" and "Link my Discord" (or who you're linked as, with Unlink).
   - Grower Community (home, directory and Gamer mode): the same bar under the page's buttons.
   Linking happens on the store's own link page (/apps/simulator/v1/discord): sign in to Discord, come back, tap
   "Link my farm". Discord only ever shows a player's gamertag. Talks only to this store's own app address. */
(function () {
  'use strict';
  if (window.GLLFDiscord) return;
  var API = '/apps/simulator/v1/', D = null, SIG = '';
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function load() {
    return fetch(API + 'discord/me', { credentials: 'same-origin', headers: { accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (j) { if (j && (j.invite || j.on)) { D = j; paint(true); } }, function () {});
  }
  function css() {
    if (document.getElementById('gllf-dc-css')) return;
    var s = document.createElement('style'); s.id = 'gllf-dc-css';
    s.textContent = '.gllf-dc{display:flex;flex-wrap:wrap;align-items:center;gap:8px;margin:12px 0;padding:10px 14px;border-radius:16px;background:#f3ecfa;border:1px solid #e0d2f0;color:#2c1f40;font:600 15px/1.35 Lato,system-ui,sans-serif}' +
      '.gllf-dc__t{flex:1 1 220px;min-width:0}.gllf-dc__t b{color:#2c1f40}.gllf-dc__b{display:inline-flex;align-items:center;gap:6px;min-height:40px;padding:8px 14px;border-radius:999px;border:0;background:#5b33a8;color:#fff;font:800 14px Lato,system-ui,sans-serif;text-decoration:none;cursor:pointer;white-space:nowrap}' +
      '.gllf-dc__b--ghost{background:#fff;color:#2c1f40;border:1px solid #cdbfe0}.gllf-dc__ok{display:inline-flex;align-items:center;gap:4px;font-weight:800;color:#2c1f40}' +
      '[data-gllf-dc-row]{margin:10px 0 0;display:flex;flex-wrap:wrap;gap:6px;align-items:center}';
    document.head.appendChild(s);
  }
  /* the buttons; cls = the button look of the place they sit in */
  function buttons(cls, ghost) {
    var h = '';
    if (D.invite) h += '<a class="' + cls + '" href="' + esc(D.invite) + '" target="_blank" rel="noopener noreferrer">💬 Join our Discord</a>';
    if (D.on) {
      if (D.linked) h += '<span class="gllf-dc__ok">✅ Discord: @' + esc(D.linked.username) + '</span><button class="' + ghost + '" type="button" data-gllf-dc-un>Unlink</button>';
      else if (D.signedIn && D.gamertag && D.start) h += '<a class="' + ghost + '" href="' + esc(D.start) + '">🔗 Link my Discord</a>';
      else h += '<a class="' + ghost + '" href="' + API + 'discord">🔗 Link my Discord</a>';
    }
    return h;
  }
  function bar() {
    return '<div class="gllf-dc" data-gllf-dc-bar><span class="gllf-dc__t"><b>Lavender Farm Simulator Discord</b> · game nights, the Derby, farm news and Huckleberry and Finnegan. ' +
      (D.linked ? 'Your rank and badges show there.' : 'Link your farm to get your rank and badges.') + '</span>' + buttons('gllf-dc__b', 'gllf-dc__b gllf-dc__b--ghost') + '</div>';
  }
  function bind(el) {
    var un = el.querySelector('[data-gllf-dc-un]'); if (!un) return;
    un.addEventListener('click', function () {
      if (!window.confirm('Unlink your farm from Discord? Your game roles there will be removed.')) return;
      un.disabled = true;
      fetch(API + 'discord/unlink', { method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json', accept: 'application/json' }, body: '{}' })
        .then(function (r) { return r.json(); }).then(function () { return load(); }, function () { un.disabled = false; });
    });
  }
  function place(host, where, html, attr) {
    var old = host.parentNode && host.parentNode.querySelector(':scope > [' + attr + ']');
    if (where === 'inside') old = host.querySelector(':scope > [' + attr + ']');
    if (old && old.getAttribute('data-sig') === SIG) return;
    var t = document.createElement('div'); t.innerHTML = html; var el = t.firstChild; el.setAttribute('data-sig', SIG);
    if (old) old.replaceWith(el);
    else if (where === 'after') host.insertAdjacentElement('afterend', el);
    else if (where === 'inside') host.insertBefore(el, host.firstChild);
    bind(el);
  }
  function paint(force) {
    if (!D) return; css();
    if (force) SIG = JSON.stringify([D.invite, D.on, D.linked && D.linked.username, D.signedIn, D.gamertag]);
    /* game: Leaderboard → My farm, under its buttons */
    var gl = document.querySelectorAll('[data-gt-link]');
    for (var i = 0; i < gl.length; i++) { var p = gl[i].parentNode; if (p && p.tagName === 'P') place(p, 'after', '<p data-gllf-dc-row>' + buttons('gllf-lb__btn gllf-lb__btn--ghost', 'gllf-lb__btn gllf-lb__btn--ghost') + '</p>', 'data-gllf-dc-row'); }
    /* Grower Community home: under its chip buttons */
    var chips = document.querySelector('[data-gch] .gch-chips'); if (chips) place(chips, 'after', bar(), 'data-gllf-dc-bar');
    /* Grower Community directory: at the top */
    var dir = document.querySelector('[data-gcd]'); if (dir && !chips) { var sw = dir.querySelector(':scope > [data-gamer-switch]'); if (sw) place(sw, 'after', bar(), 'data-gllf-dc-bar'); else place(dir, 'inside', bar(), 'data-gllf-dc-bar'); }
    /* Gamer mode (Game Growers) */
    var box = document.querySelector('[data-gamer-box]'); if (box) place(box, 'inside', bar(), 'data-gllf-dc-bar');
  }
  window.GLLFDiscord = { reload: load };
  var go = function () { if (!document.querySelector('[data-gt-link],[data-gch],[data-gcd],#lfg-simulator-root')) return; load(); setInterval(function () { try { paint(false); } catch (e) {} }, 1500); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(go, 600); }); else setTimeout(go, 600);
  document.addEventListener('visibilitychange', function () { if (!document.hidden && D) load(); });
})();

